import Home4 from './home-4.vue'
export default Home4